import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { isAuthError } from '../lib/api';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (_failureCount, error) => {
        // Don't retry on authentication errors
        if (isAuthError(error)) {
          return false;
        }
        // Retry up to 2 times for other errors
        return _failureCount < 2;
      },
      staleTime: 5 * 60 * 1000, // 5 minutes - data is fresh for 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes - keep unused data in cache for 10 minutes
      refetchOnMount: 'always', // Always refetch on mount to ensure fresh data
      refetchOnReconnect: true, // Refetch when connection is restored
    },
    mutations: {
      retry: (_failureCount, error) => {
        // Don't retry mutations on authentication errors
        if (isAuthError(error)) {
          return false;
        }
        // Don't retry mutations by default
        return false;
      },
      // Optimistic updates will be handled per-mutation
      onError: (error) => {
        console.error('Mutation error:', error);
      },
    },
  },
});

interface QueryProviderProps {
  children: React.ReactNode;
}

export default function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
}
